import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { useLayerHistoryCountQuery } from "@/v2-backoffice-client/layer/history/layer.history.count.query"
import {
  AUTHORING_MIRROR_ENVIRONMENT,
  IS_CATALOG_AUTHORING_ENABLED,
} from "@/v2-backoffice-client/feature/feature.constants"

export type LayerHistoryTabBadgeProps = ComponentProps<"span"> & {
  featureCode?: string
}

/**
 * Revision-count badge for the layer sheet's History tab trigger — how many
 * times this layer's authoring row has been written (creation included).
 * Self-fetches the history count so the trigger is decorated before the tab
 * is ever opened. Renders nothing while the count is zero or unknown.
 */
function LayerHistoryTabBadge(props: LayerHistoryTabBadgeProps) {
  const { featureCode, className, ...spanProps } = props

  const { data } = useLayerHistoryCountQuery({
    skip: !featureCode || !IS_CATALOG_AUTHORING_ENABLED,
    variables: {
      input: {
        FeatureCode: String(featureCode ?? ""),
        Environment: AUTHORING_MIRROR_ENVIRONMENT,
      },
    },
  })
  const revisionCount = data?.getStudioLayerHistory?.length ?? 0

  if (revisionCount === 0) return null

  return (
    <span
      className={cn("ml-1.5 text-xs text-muted-foreground", className)}
      {...spanProps}
    >
      ({revisionCount})
    </span>
  )
}

export default LayerHistoryTabBadge
